import * as React from 'react';

const BankGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <defs>
            <path
                d="M.5 27.899H87L43.701.1.5 27.899zM37.2 15.5c0-3.6 2.9-6.5 6.501-6.5 3.599 0 6.5 2.9 6.5 6.5.098 3.6-2.901 6.5-6.5 6.5a6.487 6.487 0 01-6.501-6.5z"
                id="bank-graphic_svg__a"
            />
            <path
                d="M43.9.801L.7 28.6c-.4.3-.7.8-.7 1.299V36.1c0 .8.7 1.5 1.5 1.5h1.6v6.2h3.1v24.7H3.1v6.2H0v15.4h89.5V74.7h-3.1v-6.2h-3.1V43.7h3.1v-6.2H88c.8 0 1.5-.699 1.5-1.5v-6.2c0-.5-.2-1-.7-1.3L45.5.801a1.543 1.543 0 00-.8-.226 1.54 1.54 0 00-.8.226zm.801 2.999l38.198 24.5H6.6L44.701 3.8zM3 34.6h83.5v-3.2H3v3.2zm67.9 6.1h12.5v-3.2H70.9v3.2zm-9.2 3h3.099v-6.2H68v6.2h3.1v24.8h-3.201v6.2h-3.198v-6.2H61.7V43.7zm-12.4-3h12.5v-3.2H49.3v3.2zm-9.3 3h3.1v-6.2h3.2v6.2h3.1v24.8h-3.1v6.2h-3.2v-6.2H40V43.7zm-12.3-3h12.5v-3.2H27.7v3.2zm-9.3 3h3.101v-6.2H24.7v6.2h3.1v24.8h-3.1v6.2h-3.199v-6.2H18.4V43.7zM6.101 40.8H18.6v-3.2H6.101v3.2zM74 68.5h6.3V43.7H74v24.8zm-21.601 0H58.7V43.7h-6.301v24.8zm-21.599 0h6.3V43.7h-6.3v24.8zm-21.6 0h6.3V43.7H9.2v24.8zm61.7 6.199h12.5V71.5H70.9v3.199zm-21.6 0h12.5V71.5H49.3v3.199zm-21.6 0h12.5V71.5H27.7v3.199zm-21.599 0H18.6V71.5H6.101v3.199zM3 80.899h83.5v-3.2H3v3.2zm0 6.2h83.5v-3.2H3v3.2z"
                id="bank-graphic_svg__c"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform="translate(28 28.5)">
                <mask id="bank-graphic_svg__b" fill="#fff">
                    <use xlinkHref="#bank-graphic_svg__a" />
                </mask>
                <path
                    fill="#F26932"
                    mask="url(#bank-graphic_svg__b)"
                    d="M-4.5 32.9H92V-4.9H-4.5z"
                />
            </g>
            <path fill="#F26932" d="M28.5 115.1H115v-12.4H28.5z" />
            <g transform="translate(27 26.5)">
                <mask id="bank-graphic_svg__d" fill="#fff">
                    <use xlinkHref="#bank-graphic_svg__c" />
                </mask>
                <path
                    fill="#363A43"
                    mask="url(#bank-graphic_svg__d)"
                    d="M-5 95h99.5V-4.5H-5z"
                />
            </g>
        </g>
    </svg>
);

BankGraphicSvg.displayName = 'BankGraphicSvg';
export default BankGraphicSvg;
